import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/authentication/authSlice';
import loaderReducer from '../slices/loader';
import subscriptionReducer from '../slices/subscriptions';
import faqReducer from '../slices/faqSlice';
import productReducer from '../slices/productSlice';
import uiReducer from '../slices/uiSlice.js';
import titleReducer from '../slices/userSlice';
import searchReducer from '../slices/searchSlice';
import navigationReducer from '../slices/navigationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loader: loaderReducer,
    subscriptions: subscriptionReducer,
    faq: faqReducer,
    product: productReducer,
    ui: uiReducer,
    title: titleReducer,
    search: searchReducer,
    navigation: navigationReducer,
  },
});
